export const MuiChip = {
	defaultProps: {
		color: "primary",
	},
	styleOverrides: {
		root: {
			height: "25px",
		},
	},
};
